// src/Components/GuidesMain/Faqs.jsx
import React from "react";
import { Rocket } from "lucide-react";
import CTAButtonLink from "../CTA/CTAButtonLink.jsx";
import Seo from "../Seo.jsx";
import Collapsible from "../ui/Collapsible.jsx";
import "../Guides/guides.css";

// Import FAQ config and the category mapping from config.
import faqConfig, { categoryMapping } from "../../config/faqConfig.js";
import mainConfig from "../../config/mainConfig"; // adjust the path as needed

const Faqs = () => {
  const meta = mainConfig.faqs?.seo || {};

  // Convert the FAQ config object into an array and filter by the page "faqs".
  const faqs = Object.values(faqConfig).filter((faq) =>
    faq.pages?.includes("faqs")
  );

  // Group the FAQ items by their category.
  const groupedFaqs = faqs.reduce((acc, faq) => {
    const category = faq.category || "General";
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(faq);
    return acc;
  }, {});

  // Transform each group into an array, sorting FAQs by descending priority.
  const groupedFaqsSorted = Object.entries(groupedFaqs).map(
    ([category, faqsArray]) => {
      const sortedFaqs = faqsArray.sort((a, b) => b.priority - a.priority);
      return { category, faqs: sortedFaqs };
    }
  );

  // Sort the category groups by the priority defined in the categoryMapping.
  const groupsSortedByPriority = groupedFaqsSorted.sort((a, b) => {
    const priorityA = categoryMapping[a.category]?.priority ?? Infinity;
    const priorityB = categoryMapping[b.category]?.priority ?? Infinity;
    return priorityA - priorityB;
  });

  const ctaAbout = <CTAButtonLink
  to="/get-started/step1"
  text="Understand How Matched Betting Works in 180 Seconds"
  buttonText="Start now"
  icon={Rocket}
  tabText="Popular"
/>

  return (
    <div className="guides-content guides-content-pad menu-page">
      <Seo title={meta.title} description={meta.description} url={meta.route} />
      <h1>FAQs</h1>
      

      {groupsSortedByPriority.map((group, index) => (
        <div key={index} className="faq-category">
          {/* Use the mapping object to display a friendly title for each category */}
          <h2>{categoryMapping[group.category]?.title || group.category}</h2>
          {group.category === "official" ? ctaAbout : <></>}
          {group.faqs.map((faq, idx) => (
            <Collapsible key={idx} title={faq.title}>
              {faq.content}
            </Collapsible>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Faqs;
